import React, {useContext} from 'react';
import {Link} from 'react-router-dom'
import {Loading} from '../custom/LoadingComponent'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TaskIcon from '@mui/icons-material/Task';
import Grid from '@mui/material/Grid';
import dayjs from 'dayjs';


import { Scheduler } from "@aldabil/react-scheduler";

import AuthContext from "../context/AuthContext";
import * as Consts from '../constants/Consts';
import { TaskType, TaskStatus, RoleClient } from '../constants/Consts';
import * as DataPattern from '../constants/DataPattern';
import * as TypeConvertor from '../util/TypeConvertor';
import * as RestCall from '../../utils/network/RestCalls';
import { getAuthorizedWorksitesForContextClient } from '../../utils/auth/Security';
import * as Security from '../../utils/auth/Security';


const colorCouponStamp = "indigo";
const colorCoupon = "blue";
const colorAuthorization = "teal";
const colorCertificate = "teal";
const colorTaskCouponStamp = "#e65100";

const getReminderDescription = (reminder) => {
    var descE = "";
    var descA = "";
    var isScheduled = false;

    if(reminder.extra.eFullName)
        descE = reminder.extra.eFullName;

    if(reminder.details.authISCIR)
        descA = TypeConvertor.getAuthzIscirName( reminder.details.authISCIR );
        // descA = TypeConvertor.getAuthorizationDescription( reminder.details.authISCIR );
    else if(reminder.details.authInternal)
        descA = TypeConvertor.getAuthzInternalName( reminder.details.authInternal );

    if(reminder.scheduling?.isScheduled) {
        isScheduled = true;
    }        

    const desc = descE + " - " + descA;
    return {
            isScheduled: isScheduled,
            description: desc
           };
}

const getTaskDescription = (task) => {
    return task.id;
}

const genReminderEvent = (reminder, dayEventCount) => {
    var eventTitle;
    var eventAction;
    var startTime;
    var eventColor;
    var expirationDate;

    const hourStart = 9 + Math.trunc(dayEventCount/2);
    const minuteStart = 30 * (dayEventCount%2);
    eventTitle = reminder.extra.worksiteName;
    startTime = dayjs(reminder.details.dataReminder).hour(hourStart).minute(minuteStart);
    expirationDate = dayjs(reminder.details.dataExpirare);

    switch(reminder.details.type) {
        case Consts.REMINDER_RENEW_COUPON_STAMP:
            eventAction = 'Reminder Reinnoire Viza Talon';
            eventColor = colorCouponStamp;
            break;
        case Consts.REMINDER_RENEW_COUPON:
            eventAction = 'Reminder Reinnoire Talon';
            eventColor = colorCoupon;
            break;
        case Consts.REMINDER_RENEW_AUTHORIZATION:
            eventAction = 'Reminder Reinnoire Autorizatie';
            eventColor = colorAuthorization;
            break;
        case Consts.REMINDER_RENEW_CERTIFICATE:
            eventAction = 'Reminder Reinnoire Adeverinta';
            eventColor = colorCertificate;
            break;
        }

    const event = {
        event_id: Math.random(),
        type: Consts.CALENDAR_EVENT_TYPE_REMINDER,
        title: eventTitle,
        action: eventAction,
        start: startTime.toDate(),
        end: startTime.add(30, 'minute').toDate(),
        color: eventColor,
        expDate: expirationDate.format(DataPattern.DATE_FORMAT_RO),
        notes: [ getReminderDescription(reminder) ],
        editable: false,
        deletable: false  
      };

      return event;
} 

const genTaskEvent = (task, dayEventCount) => {
    var eventTitle;
    var eventAction;
    var startTime;
    var eventColor;
    var expirationDate;
    var eventLink;

    const hourStart = 9 + Math.trunc(dayEventCount/2);
    const minuteStart = 30 * (dayEventCount%2);
    startTime = dayjs(task.step0.scheduledDate).hour(hourStart).minute(minuteStart);
    eventTitle = task.step1.worksiteName;
    expirationDate = dayjs(task.step0.scheduledDate);

    switch(task.details.type) {
        case TaskType.CouponStampRenewal:
            eventAction = 'Task Reinnoire Viza Talon';
            eventColor = colorTaskCouponStamp;
            eventLink = `/rsvti/deserventi/tasks/couponstamp/${task.id}`
            break;
        case TaskType.CertificateRenewal:
            eventAction = 'Task Reinnoire Adeverinta';
            eventColor = colorTaskCouponStamp;
            eventLink = `/rsvti/deserventi/tasks/certificate/${task.id}`
            break;
        }

    const event = {
        event_id: Math.random(),
        type: Consts.CALENDAR_EVENT_TYPE_RSVTITASK,
        title: eventTitle,
        action: eventAction,
        start: startTime.toDate(),
        end: startTime.add(30, 'minute').toDate(),
        color: eventColor,
        taskId: getTaskDescription(task),
        taskLink: eventLink,
        editable: false,
        deletable: false  
      };
  
      return event;
}

const getEventDescription = (event) => {
    if(event.type === Consts.CALENDAR_EVENT_TYPE_REMINDER) {
        return getReminderDescription(event);
    }
    else if(event.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK) {
        return getTaskDescription(event);
    }
    else {
        throw new Error('Unknown Calender Event!');
    }
}

const genEvent = (event, dayEventCount) => {
    if(event.type === Consts.CALENDAR_EVENT_TYPE_REMINDER) {
        return genReminderEvent(event, dayEventCount);
    }
    else if(event.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK) {
        return genTaskEvent(event, dayEventCount);
    }
    else {
        throw new Error('Unknown Calender Event!');
    }
}


// can we simply used the event.id + type as a key? 
const getKey = (event) => {
    if(event.type === Consts.CALENDAR_EVENT_TYPE_REMINDER) {
        return dayjs(event.details.dataReminder).toISOString().slice(0,10) + 
            '-' +
            event.details.type +
            '-' +
            event.extra.worksiteId;
    }
    else if(event.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK) {
        return dayjs(event.step0.scheduledDate).toISOString().slice(0,10) + 
            '-' +
            event.details.type +
            '-' +
            event.id;
    }
    else {
        throw new Error('Unknown Calender Event!');
    }
} 

const getEventDateKey = (event) => {
    if(event.type === Consts.CALENDAR_EVENT_TYPE_REMINDER) {
        return dayjs(event.details.dataReminder).toISOString().slice(0,10);
    }
    else if(event.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK) {
        return dayjs(event.step0.scheduledDate).toISOString().slice(0,10); 
    }
    else {
        throw new Error('Unknown Calender Event!');
    }
} 


function DeserventiCalendar(props) {
    console.log('___DeserventiCalendar___');
    const authContext = useContext(AuthContext);


    // const getEvents = (events, query) => {
    const getEvents = (events) => {
        const calendarEventMap = new Map();
        const dateMap = new Map();                  // days and number of events/day map 

        events.forEach(newEvent => {
            const remKey = getKey(newEvent);
            if(calendarEventMap.has(remKey)) {
                const calEvent = calendarEventMap.get(remKey);
                calEvent.notes.push( getEventDescription(newEvent) );
            }
            else {
                const dateKey = getEventDateKey(newEvent);
                var dayEventCount = 0;
                if(dateMap.has(dateKey)){
                    dayEventCount = dateMap.get(dateKey) + 1;
                }
                dateMap.set(dateKey, dayEventCount);

                calendarEventMap.set( remKey, genEvent(newEvent, dayEventCount) );
            }
        });

        return Array.from( calendarEventMap.values() );
    }


    const fetchCalendarItemsForClient = async (clientId, authzWorksites, startDate, endDate) => {
        return RestCall.fetchCalendarItemsForClient(clientId, authzWorksites, startDate, endDate)
                        .then( (events) => events.filter((item) => {return item.type === Consts.CALENDAR_EVENT_TYPE_REMINDER ||
                                                                    (item.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK && 
                                                                     item.details.activeStep > 1 && 
                                                                     item.details.status === TaskStatus.InProgress)
                                                        } ))
                        .then( (events) => getEvents(events) )
                        .catch(error => console.log(error));

    }


    const fetchCalendarItems = async (query) => {
        const qStart = dayjs(query.start);
        const qEnd = dayjs(query.end);

        const startDate = qStart.toISOString().slice(0,10);
        const endDate = qEnd.toISOString().slice(0,10)
        console.log("Start: " + startDate);
        console.log("End: " + endDate);    

        // TODO - What to do for COREVO ADMIN user

        var promiseArray = [];
        var clientId;
        var authzWorksites;

        if(Security.isUserOfClientEmployer()) {
            const myClientId = Security.getSignedInUser().generalSection.clientId;
            const myClient = props.clients.find((client) => client.id === myClientId);
            const externalProviderId = myClient.generalSection.rsvtiServiceByClientId;

            clientId = externalProviderId;
            if( Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) ) {
                authzWorksites = getAuthorizedWorksitesForContextClient();
            }
            else{
                const wsIds = [];
                for(let ws of props.worksites) {
                    wsIds.push(ws.id);
                }
                authzWorksites = wsIds;
            }
        }
        else {
            clientId = authContext.afUser.generalSection.clientId;
            authzWorksites = getAuthorizedWorksitesForContextClient();
        }

        promiseArray.push(fetchCalendarItemsForClient(clientId, authzWorksites, startDate, endDate));

        for(let subcon of authContext.subcontracted) {
            if(subcon.generalSection.active) {
                promiseArray.push(fetchCalendarItemsForClient(subcon.generalSection.subconForClientId, subcon.generalSection.permissionedWS, startDate, endDate));
            }
        }

        return Promise.all(promiseArray)
            .then((result) => result.flat());
    }


    if (props.dataStatus.isLoading) {
        return (
            <Container maxWidth="xl" >
                <Box px={{ xs: 3, sm: 7 }}>
                    <Loading />
                </Box>
            </Container>
        );
    }
    else {
        return (
            <Container maxWidth="xl">

                <Stack spacing={1} sx={{ marginBottom: 2 }}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Reminder Calendar Deserventi</Typography>
                        </Breadcrumbs>
                    </Box>
                    <hr />

                    <Box>
                        <Scheduler
                            view="month"
                            day={null}
                            // selectedDate = {new Date(2023, 1, 17)}
                            getRemoteEvents={fetchCalendarItems}
                            viewerTitleComponent={(event) => {
                                return(
                                    <React.Fragment key={Math.random()}>
                                        <Typography sx={{ fontSize: 16 }}> {event.action} </Typography>
                                        <Typography sx={{ fontSize: 16 }}> {event.title} </Typography>
                                    </React.Fragment>
                                );
                            }}
                            viewerExtraComponent={(fields, event) => {
                                if(event.type === Consts.CALENDAR_EVENT_TYPE_REMINDER)
                                    return( <CalendarReminderEC event = {event}/> );
                                else if(event.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK)
                                    return( <CalendarTaskEC event = {event}/> );
                                else
                                    return( <React.Fragment key={Math.random()}></React.Fragment> );
                            }}
                        />
                    </Box>

                </Stack>

            </Container>
        );
    }
}

const CalendarReminderEC = ({event}) => {
    return (
        <React.Fragment>
            <p>Expira pe: {event.expDate}</p>
            <Grid container spacing={0}>
                {event.notes
                    .sort((a, b) => {
                        const descriptionA = a.description.toUpperCase(); // ignore upper and lowercase
                        const descriptionB = b.description.toUpperCase(); // ignore upper and lowercase
                        if (descriptionA < descriptionB) {
                          return -1;
                        }
                        if (descriptionA > descriptionB) {
                          return 1;
                        }
                        // names must be equal
                        return 0;
                      })
                    .map(eNote => (
                        <React.Fragment key={Math.random()}>
                            <Grid item xs={1}>
                                {eNote.isScheduled ?
                                    <TaskIcon key={Math.random()} color="success" fontSize="small" sx={{mb: 1}} />
                                        :
                                    <React.Fragment key={Math.random()}></React.Fragment>
                                }
                            </Grid>
                            <Grid item xs={11}>
                                <Typography sx={{ fontSize: 12 }} key={Math.random()} color="text.primary">
                                    {eNote.description}
                                </Typography>
                            </Grid>
                        </React.Fragment>
                    ))
                }
            </Grid>
        </React.Fragment>
    );
}

const CalendarTaskEC = ({event}) => {
    return (
        <React.Fragment>
            <Box sx={{mt: 1, mb: 1}}>
                <Link to={event.taskLink}>
                    {event.action} - #{event.taskId}
                </Link>
            </Box>
        </React.Fragment>
    );
}

export default DeserventiCalendar;